<template>
  <v-container>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <DeliveryFilter
          @updateFilter="get_data()"
          :filters="filters"
          class="mb-4"
        />
        <TransactionTable
          :data_loaded="data_loaded"
          :items="items"
          :page="page"
          :total="total"
          @updatePage="updatePage"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import DeliveryFilter from "@/components/delivery/show/DeliveryFilter";
import TransactionTable from "@/components/delivery/show/TransactionTable";
export default {
  name: "Show",
  data() {
    return {
      filters: {
        start_date: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        end_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      },
      data_loaded: false,
      items: [],
      page: 1,
      total: 0,
    };
  },
  components: {
    DeliveryFilter,
    TransactionTable,
  },
  methods: {
    get_data() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `delivery-transactions/${this.$route.params.id}?page=${this.page} &start_date=${this.filters.start_date}&end_date=${this.filters.end_date}`,
          },
        })
        .then((res) => {
          this.data_loaded = true;
          const data = res.data.data;
          this.items = data.data;
          this.total = data.meta.last_page;
          this.page = data.meta.current_page;
        });
    },
    updatePage(page) {
      this.page = page;
      this.get_data();
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>
